import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.starts-with";

/* global Config */
// Vendor Libs
import { LOCATION_CHANGE, push } from 'redux-first-history';
import { batch } from 'react-redux'; // Dish Tech React

import { actionsServiceCaller } from '@dishtech-react/utils'; // Action Types

import { actionTypes } from '../action-types';

var handleLocationChange = function handleLocationChange(dispatch, action) {
  var _action$payload = action.payload;
  _action$payload = _action$payload === void 0 ? {} : _action$payload;
  var location = _action$payload.location,
      _action$payload$locat = _action$payload.location;
  _action$payload$locat = _action$payload$locat === void 0 ? {} : _action$payload$locat;
  var pathname = _action$payload$locat.pathname;

  if (pathname === '/') {
    batch(function () {
      // NOTE: This has to match `basePath` route in app.js
      dispatch(push(Config.base.homePath));
      dispatch({
        payload: {
          location: {
            pathname: Config.base.homePath
          },
          routerParams: ''
        },
        type: actionTypes.ROUTER_UPDATE
      });
    });
  } else {
    var pathAndParams = pathname.replace('/', '').split('/');
    dispatch({
      payload: {
        location: location,
        routerParams: pathAndParams.length < 2 ? '' : pathAndParams[1]
      },
      type: actionTypes.ROUTER_UPDATE
    });
  }
};

var submitAuth = function submitAuth(dispatch, isAuthorized, credentialsNonExpired) {
  if (Config.oauth.disabled && Config.oauth.disabled.toString() === 'true') {
    if (isAuthorized !== true || credentialsNonExpired !== true) {
      dispatch({
        payload: {
          user: {
            isAuthorized: true,
            credentialsNonExpired: true
          }
        },
        type: actionTypes.AUTH_SET_USER
      });
    }
  } else {
    var handleFetched = function handleFetched(jsonResponse) {
      if (jsonResponse.authorities && jsonResponse.authorities.length) {
        var expireName = 'sessionExpireTime';
        var currentSessionExpireTime = localStorage.getItem(expireName);

        if (currentSessionExpireTime) {
          var dateNow = new Date();
          var dateStorage = new Date(currentSessionExpireTime);

          if (dateNow > dateStorage) {
            localStorage.removeItem(expireName);
          }
        }

        if (!localStorage.getItem(expireName)) {
          var seconds = jsonResponse.authorities[0].client.accessTokenValiditySeconds;
          var date = new Date(new Date().getTime() + seconds * 1000);
          localStorage.setItem(expireName, date);
        }
      }

      dispatch({
        payload: {
          user: jsonResponse
        },
        type: actionTypes.AUTH_SET_USER
      });
    };

    var handleError = function handleError(error, status, data) {
      console.error(error);

      if (status && status === 403) {
        dispatch({
          payload: {
            user: data
          },
          type: actionTypes.AUTH_SET_USER
        });
      }
    };

    var config = {
      baseUrl: Config.base.userInfoPath,
      contentType: 'application/json',
      crossDomain: false,
      method: 'GET',
      responseType: 'json',
      timeout: 60000
    };
    var actionParams = {
      handleFetched: handleFetched,
      handleError: handleError,
      serviceConfig: config
    };
    return actionsServiceCaller(actionParams);
  }
};

var handleRouterUpdate = function handleRouterUpdate(dispatch, _ref, _ref2) {
  var _ref$location = _ref.location;
  _ref$location = _ref$location === void 0 ? {} : _ref$location;
  var newPathName = _ref$location.pathname;
  var _ref2$router = _ref2.router;
  _ref2$router = _ref2$router === void 0 ? {} : _ref2$router;
  var _ref2$router$location = _ref2$router.location;
  _ref2$router$location = _ref2$router$location === void 0 ? {} : _ref2$router$location;
  var pathname = _ref2$router$location.pathname,
      _ref2$auth = _ref2.auth;
  _ref2$auth = _ref2$auth === void 0 ? {} : _ref2$auth;
  var _ref2$auth$user = _ref2$auth.user;
  _ref2$auth$user = _ref2$auth$user === void 0 ? {} : _ref2$auth$user;
  var credentialsNonExpired = _ref2$auth$user.credentialsNonExpired,
      isAuthorized = _ref2$auth$user.isAuthorized;

  if (pathname === '' && newPathName !== Config.base.loginPath && newPathName !== Config.base.forgotPasswordPath && (!Config.base.resetPasswordPath || !newPathName.startsWith(Config.base.resetPasswordPath.replace('/*', '')))) {
    submitAuth(dispatch, isAuthorized, credentialsNonExpired);
  }
};

export var routerMiddleware = function routerMiddleware(store) {
  return function (next) {
    return function (action) {
      var _actions;

      var dispatch = store.dispatch,
          getState = store.getState;

      var _ref3 = action || {},
          type = _ref3.type;

      var state = getState();
      next(action);
      var actions = (_actions = {}, _actions[LOCATION_CHANGE] = function () {
        return handleLocationChange(dispatch, action);
      }, _actions[actionTypes.ROUTER_UPDATE] = function () {
        return handleRouterUpdate(dispatch, action.payload, state);
      }, _actions);

      if (actions[type]) {
        actions[type]();
      }
    };
  };
};